export enum ItemStatus {
  Active = 1,
  Used = 2
}

export enum ItemType {
  Reward = 1,
  Offer = 2
}

export interface RewardOfferItemI {
  id: number,
  leftImageUrl: string,
  topTitle: string,
  bottomTitle: string,
  callToActionText: string,
  status: ItemStatus,
  expirationDate: string,
  detail: string,
  type: ItemType
}